import { SupportRequestType } from '@court-sync/shared';

export interface SupportUrlParams {
  type: SupportRequestType;
  subject?: string;
  message?: string;
  academyId?: string;
}

/**
 * Build a URL to the support form with query parameters for auto-population
 * 
 * @param params - Parameters to include in the URL
 * @returns URL string with query parameters
 * 
 * @example
 * ```typescript
 * const url = buildSupportUrl({
 *   type: 'technical',
 *   subject: 'Bug Report',
 *   message: 'I found an issue...'
 * });
 * // Returns: /settings?tab=support&type=technical&subject=Bug%20Report&message=I%20found%20an%20issue...
 * ```
 */
export function buildSupportUrl(params: SupportUrlParams): string {
  // eslint-disable-next-line no-undef
  const searchParams = new URLSearchParams();
  searchParams.set('tab', 'support');
  searchParams.set('type', params.type);
  
  if (params.subject) {
    searchParams.set('subject', params.subject);
  }
  if (params.message) {
    searchParams.set('message', params.message);
  }
  if (params.academyId) {
    searchParams.set('academyId', params.academyId);
  }
  
  return `/settings?${searchParams.toString()}`;
}
